import * as yup from 'yup';

export const schema = yup
	.object({
		subject: yup
			.string()
			.required('Это поле необходимо заполнить')
			.min(3, 'Сообщение слишком короткое'),
		comment: yup
			.string()
			.required('Это поле необходимо заполнить')
			.min(3, 'Сообщение слишком короткое'),
	})
	.required();

export interface Form {
	subject: string;
	comment: string;
}
